import { Card, CardHeader, CardContent } from "@mui/material";

import { i18n } from "services/i18nService";

import { BigCommerce } from "views/Carts/Cart/Instructions/BigCommerce";
import { PayPal } from "views/Carts/Cart/Instructions/PayPal";
import { Shopify } from "views/Carts/Cart/Instructions/Shopify";

const INSTRUCTION_LISTS = { Shopify, BigCommerce, PayPal };

export function Instructions(props) {
  const { connectionType, shopifyAppType } = props;

  const InstructionList = INSTRUCTION_LISTS[connectionType] || null;

  if (!InstructionList) {
    return null;
  }

  return (
    <Card variant="outlined">
      <CardHeader
        sx={{ pb: 0 }}
        title={i18n("cart.Instructions.header")}
        variant="subtitle1"
      />
      <CardContent sx={{ p: "0 16px 16px 16px" }}>
        <InstructionList shopifyAppType={shopifyAppType} />
      </CardContent>
    </Card>
  );
}
